import React, { ComponentType, useEffect, useState } from 'react';
import { useFeatureFlags } from '@funtech-int/yango-shared';

import { RemountOnKey } from '../RemountOnKey/RemountOnKey';

export function withVisibilityRemount<P extends object>(WrappedComponent: ComponentType<P>) {
    const Component = (props: P) => {
        const [key, setKey] = useState(0);
        const showcaseRefetchTime = useFeatureFlags().flags.get(
            'showcaseRefetchTime',
            'number',
            3600
        );

        useEffect(() => {
            let timestamp = Date.now();
            function handleEvent() {
                if (document.hidden) {
                    timestamp = Date.now();
                } else if (Date.now() - timestamp > showcaseRefetchTime * 1000) {
                    setKey((prevKey) => prevKey + 1);
                }
            }

            document.addEventListener('visibilitychange', handleEvent);

            return () => document.removeEventListener('visibilitychange', handleEvent);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return (
            <RemountOnKey mountKey={key}>
                <WrappedComponent {...props} />
            </RemountOnKey>
        );
    };

    Component.displayName = `withVisibilityRemount(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;

    return Component;
}
